<!-- 图文富文本显示 -->
<template>
  <div
      class="rich-text"
      ref="content"
      v-html="contentShow"
  >
  </div>
</template>

<script>
import {TripleDESDecrypt} from "@/common/util";
import html2canvas from "html2canvas";

export default {
  props: {
    content: {
      default: '',
    },
    isEncrypt: {
      default: true,
    },
    watermark: {
      default: '',
    },
  },
  data() {
    return {
      iframeHeight: 0,
      contentShow: '',
      userInfo: {},
    };
  },
  mounted() {
    try {
      this.userInfo = JSON.parse(localStorage.getItem('user_info') || `{}`);
    } catch (e) {
      this.userInfo = {};
    }
    if (this.isEncrypt) {
      this.contentShow = TripleDESDecrypt(this.content);
    } else {
      this.contentShow = this.content;
    }
    this.$nextTick(() => {
      const windowHeight = document.documentElement.clientHeight * 0.7;
      const boxHeight = this.$refs.content.offsetHeight;
      const nums = Math.floor(boxHeight / windowHeight);
      const fontSize = parseInt(this.$refs.content.offsetWidth / 12);
      const cover = document.createElement('div');
      cover.className = "cover";
      cover.style.height = boxHeight + 'px';
      cover.style.lineHeight = fontSize + 'px';
      cover.style.position = 'absolute';
      cover.style.left = '50%';
      cover.style.display = 'flex';
      cover.style.flexDirection = 'column';
      cover.style.alignItems = 'center';
      cover.style.justifyContent = 'center';
      cover.style.transform = 'translateX(-50%)';
      cover.style.pointerEvents = 'none' // 取消所有事件
      for(let i = 0; i < nums; i++) {
        let c = document.createElement('div')
        c.className = "cover"
        c.style.width = 'max-content';
        c.style.height = windowHeight + 'px';
        c.style.fontSize = fontSize + 'px';
        c.style.transform = "rotateZ(315deg)";
        c.style.color = "rgba(0, 0, 0, 0.20)";
        c.style.fontWeight = 'bold';
        c.style.display = 'flex';
        c.style.flexDirection = 'column';
        c.style.alignItems = 'center';
        c.style.justifyContent = 'center';
        c.innerText = this.watermark || this.userInfo.phone || '搞一下';
        c.style.pointerEvents = 'none' // 取消所有事件
        cover.appendChild(c);
      }
      this.$refs.content.appendChild(cover);
      document.documentElement.scrollTop = document.body.scrollTop = 0;
      setTimeout(() => {
        html2canvas(this.$refs.content, {
          allowTaint: true
        }).then((canvas) => {
          this.$refs.content.innerHTML = '';
          this.$refs.content.appendChild(canvas);
        }).catch(() => {
          this.$refs.content.innerHTML = '';
        });
      }, 50);
    });
  },
}
</script>

<style scoped>

.rich-text{
  background: #FFFFFF!important;
  /*display: flex;*/
  /*flex-direction: column;*/
  /*align-items: center;*/
  /*position: relative;*/
}

</style>
